import { axios } from '@/utils/request'

const api = {
  master: '/master/master',
  model: '/enterprise/model',
  installLabel: '/master/installLabel',
  masterPrice: '/master/masterPrice',
  masterContract: '/master/masterContract',
  userArea: '/master/userArea',
  province: '/basicdata/province',
  city: '/basicdata/city',
  area: '/basicdata/area',
  user: '/system/user',
  role: '/system/role'
}

export function openOrder (parameter) {
  return axios({
    url: '/master/master/updateOrderReceiveStatus',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 批量审核
export function batchAuditArea (parameter) {
  return axios({
    url: '/master/userArea/batchAuditArea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function selectFindAll(parameter) {
  return axios({
    url: '/system/dict/data/findAll',
    method: 'get',
    params: parameter
  })
}

// 身份证识别接口
export function idCardOrc(parameter) {
  return axios({
    url: '/master/masterApp/idCardOrc',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//失败上传处理
export function downloadErrorMaster(parameter) {
  return axios({
    url: api.master + '/downloadErrorMaster',
    method: 'post',
    data: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 审核通过
export function aduitUserArea(parameter) {
  return axios({
    url: '/master/userArea/aduitUserArea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 审核不通过
export function noAduitUserArea(parameter) {
  return axios({
    url: '/master/userArea/noAduitUserArea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 省市下已经过滤的服务区域
export function selectMasterChooseArea(parameter) {
  return axios({
    url: '/master/userArea/selectMasterChooseArea',
    method: 'get',
    params: parameter
  })
}
// 会员
export function employeeInfoPush(parameter) {
  return axios({
    url: '/caixinPayApi/enterprise/employeeInfoPush',
    method: 'get',
    params: parameter
  })
}

// 履历列表
export function MasterOperation(parameter) {
  return axios({
    url: '/master/MasterOperation/list',
    method: 'get',
    params: parameter
  })
}
// 导出
export function exportMaster(parameter) {
  return axios({
    url: '/master/master/exportMaster',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  })
}
// 电子围栏
export function Pointget(parameter) {//团队电子围栏查看
  return axios({
    url: '/master/areapoint/get/' + `${parameter}`,
    method: 'get',
  })
}
// 修改电子围栏
export function addAreaPoint(parameter) {
  return axios({
    url: '/master/areapoint/addAreaPoint',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 详情合同列表
export function queryContractByMaster(parameter) {
  return axios({
    url: api.masterContract + '/queryContractByMaster',
    method: 'get',
    params: parameter
  })
}
// 合同删除
export function deleteMasterContract(parameter) {
  return axios({
    url: api.masterContract + '/deleteMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 合同禁用
export function disableMasterContract(parameter) {
  return axios({
    url: api.masterContract + '/disableMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 合同启用
export function enableMasterContract(parameter) {
  return axios({
    url: api.masterContract + '/enableMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 合同修改
export function editMasterContract(parameter) {
  return axios({
    url: api.masterContract + '/editMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 设为主合同
export function toMainMasterContract(parameter) {
  return axios({
    url: api.masterContract + '/toMainMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 取消主合同
export function noMainMasterContract(parameter) {
  return axios({
    url: api.masterContract + '/noMainMasterContract',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function queryMaster(parameter) {
  return axios({
    url: api.master + '/queryMaster',
    method: 'get',
    params: parameter
  })
}

// 金额信息
export function queryMasterPrice(parameter) {
  return axios({
    url: api.masterPrice + '/queryMasterPrice',
    method: 'get',
    params: parameter
  })
}
//修改金额
export function editMasterPrice(parameter) {
  return axios({
    url: api.masterPrice + '/editMasterPrice',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
//修改密码
export function resetMasterPwd(parameter) {
  return axios({
    url: api.user + '/resetMasterPwd',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function addMaster(parameter) {
  return axios({
    url: api.master + '/addMaster',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function editMaster(parameter) {
  return axios({
    url: api.master + '/editMaster',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 详情
export function getList(parameter) {
  return axios({
    url: api.master + '/get',
    method: 'get',
    params: parameter
  })
}

// 师傅负责人
export function findByDeptId(parameter) {
  return axios({
    url: `/system/user/findByDeptId/${106}`,
    method: 'get',
    params: parameter
  })
}
// 角色
export function roleAll(parameter) {
  return axios({
    url: '/system/role/masterRoleList',
    method: 'get',
    params: parameter
  })
}
// 标签
export function selectALLInstallLabel(parameter) {
  return axios({
    url: api.installLabel + '/selectALLInstallLabel',
    method: 'get',
    params: parameter
  })
}
// 配件
export function queryMasterAccessoryPrice(parameter) {
  return axios({
    url: api.masterPrice + '/queryMasterAccessoryPrice',
    method: 'get',
    params: parameter
  })
}

// 服务区
export function queryUserArea(parameter) {
  return axios({
    url: api.userArea + '/queryUserArea',
    method: 'get',
    params: parameter
  })
}

export function deleteUserArea(parameter) {
  return axios({
    url: api.userArea + '/deleteUserArea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//批量删除
export function batchDeleteUserArea(parameter) {
  return axios({
    url: api.userArea + '/batchDeleteUserArea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function addUserArea(parameter) {
  return axios({
    url: api.userArea + '/addUserArea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 标签
export function selectInstallTypeAndLabel(parameter) {
  return axios({
    url: api.installLabel + '/selectInstallTypeAndLabel',
    method: 'get',
    params: parameter
  })
}

export function deleteChannel(parameter) {
  return axios({
    url: api.info + '/deleteChannel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 省市区下拉
export function getSelectAllProvince(parameter) {
  return axios({
    url: api.province + '/selectAllProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectCityName(parameter) {
  return axios({
    url: api.city + '/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectAreaName(parameter) {
  return axios({
    url: api.area + '/selectAreaName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//禁用
export function forbiddenMaster(parameter) {
  return axios({
    url: api.master + '/forbiddenMaster',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//启动
export function enableMaster(parameter) {
  return axios({
    url: api.master + '/enableMaster',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//黑名单
export function blackMaster(parameter) {
  return axios({
    url: api.master + '/blackMaster',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
//
// export const remindMap = {
//   '0': '否',
//   '1': '是'
// }
//
// export const fieldType = {
//   '0': '单选框',
//   '1': '输入框',
//   '2': '单选+输入'
// }

export const channelExport = api.channel + '/export'
